// extracted by mini-css-extract-plugin
module.exports = {"lineChart":"LineChart_lineChart__2jFh4","xaxisLabels":"LineChart_xaxisLabels__1JaPl","loader":"LineChart_loader__2xDVY"};